var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{staticClass:"u-b1",attrs:{"disabled":_vm.offerHasErrors,"icon":_vm.showIcon ? 'plus' : undefined,"data-test":"offer-order","type":"primary"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.$t('Naruči'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }